import { render } from "./Header.vue?vue&type=template&id=618838ee&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=618838ee&scoped=true&lang=css"

import exportComponent from "/Users/fee/Documents/JavaProjects/高校宿舍管理系统java/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618838ee"]])

export default __exports__